module.exports = __webpack_public_path__ + "static/img/p3.00f1873c.png";